module.exports = "https://static.wmbcdn.com/uniweb/images/c3d578f71b1ca257ba4baaf0af857a80.svg";